import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export default function VIPNotEnrolledReadOnlyView({ vipStatus, listing }) {
  const isEligible = vipStatus.canEnroll;
  const listingStatus = vipStatus.listingStatus || listing.status;

  return (
    <div className="space-y-6">
      {/* Status Message */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <InformationCircleIcon className="h-8 w-8 text-gray-600" />
          <h2 className="text-2xl font-bold text-gray-900">VIP Network Status</h2>
        </div>
        <p className="text-gray-700 mb-2">
          This listing is <strong>not enrolled</strong> in the VIP Network.
        </p>
      </div>

      {/* Eligibility Information */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Enrollment Eligibility</h3>

        {isEligible ? (
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <svg className="h-5 w-5 text-green-500 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-gray-700">
                This listing <strong>is eligible</strong> for VIP Network enrollment.
              </p>
            </div>
            <div className="ml-7 mt-3 p-3 bg-blue-50 border border-blue-200 rounded">
              <p className="text-sm text-blue-800">
                <strong>Note:</strong> Businesses must enroll through their industry account. Platform administrators cannot enroll listings on behalf of businesses as enrollment requires the business owner to accept the VIP Partner Agreement.
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <p className="text-gray-700">
                This listing is <strong>not currently eligible</strong> for VIP Network enrollment.
              </p>
            </div>
            <div className="ml-7 mt-2 space-y-1">
              <p className="text-sm text-gray-600">
                <strong>Listing Status:</strong> {listingStatus}
              </p>
              {listingStatus === 'unverified' && (
                <p className="text-sm text-gray-600 mt-2">
                  The listing must be <strong>verified</strong> before it can join the VIP Network.
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Admin Information */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Administrator Information</h3>
        <div className="space-y-2 text-sm text-gray-700">
          <p>
            VIP Network enrollment is a self-service process that must be completed by the business owner or manager through their industry account.
          </p>
          <p>
            Business owners with a verified listing can access the VIP enrollment form from their listing detail page in the industry portal.
          </p>
          <p className="mt-3 text-gray-600">
            <strong>Need to manually enable VIP for this listing?</strong> Use the VIP Network toggle in the Edit Listing form on the Overview tab.
          </p>
        </div>
      </div>
    </div>
  );
}
